module.exports = __webpack_public_path__ + "img/industry-banner-02.22cb1ae6.png";